import { createSelector } from 'reselect';
import { StateInterface } from '../types/states';
const selectRouterDomain = (state: StateInterface) => state.router;
const selectLocation = createSelector(selectRouterDomain, (router) => router.location);
const selectLocationPathname = createSelector(selectLocation, (location) => location.pathname);
const selectLocationQuery = createSelector(selectLocation, (location) => location?.query || undefined);
const selectIsCreateApplicationRoute = createSelector(selectLocationPathname, (pathname) => {
    return pathname.startsWith('/new-application/');
});
const selectUserIdFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const contentId = pathArray[2];
    const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return pattern.test(contentId) ? contentId : undefined;
});
const selectContentIdFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const contentId = pathArray[4];
    const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return pattern.test(contentId) ? contentId : undefined;
});
const selectApartmentStatusFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const status = pathArray[2];
    return status;
});
const selectStepNumberFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const stepNumber = pathArray[6];
    return stepNumber ? Number(stepNumber) : undefined;
});
const selectNewApplicationStepNumberFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const stepNumber = pathArray[4];
    return stepNumber ? Number(stepNumber) : undefined;
});
const selectNewApplicationApartmentCodeFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const apartmentCode = pathArray[2];
    return apartmentCode;
});
const selectBeforeLoginStepNumberFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const stepNumber = pathArray[4];
    return stepNumber ? Number(stepNumber) : undefined;
});
const selectInstantRentStepNumberFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const stepNumber = pathArray[4];
    return stepNumber ? Number(stepNumber) : undefined;
});
const selectAfterShowingStepNumberFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const stepNumber = pathArray[4];
    return stepNumber ? Number(stepNumber) : undefined;
});
const selectApplicationCodeFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const firstCode = pathArray[2];
    return firstCode;
});
const selectEmailFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const email = pathArray[3];
    return email;
});
const selectCodeFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const code = pathArray[4];
    return code;
});
const selectApartmentFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const showing = pathArray[4];
    return showing;
});
const selectShowingFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const showing = pathArray[6];
    return showing;
});
const selectReserveCodeFromPathname = createSelector(selectLocationPathname, (pathname) => {
    const pathArray = pathname.split('/');
    const code = pathArray[2];
    return code;
});
export { selectLocationPathname, selectLocationQuery, selectUserIdFromPathname, selectContentIdFromPathname, selectStepNumberFromPathname, selectNewApplicationStepNumberFromPathname, selectNewApplicationApartmentCodeFromPathname, selectBeforeLoginStepNumberFromPathname, selectInstantRentStepNumberFromPathname, selectAfterShowingStepNumberFromPathname, selectApplicationCodeFromPathname, selectEmailFromPathname, selectCodeFromPathname, selectIsCreateApplicationRoute, selectApartmentFromPathname, selectShowingFromPathname, selectReserveCodeFromPathname, selectApartmentStatusFromPathname };
